import React from 'react';
import Label from '.';
import styled from 'styled-components';

interface LabelSetProps {
  required?: boolean;
  infoLink?: IinfoLink;
  label?: string;
  description?: string;
  labelWidth?: string | number;
  align?: 'left' | 'center' | 'right'; // 🆕 정렬 옵션
}

const LabelWrap = styled.div<{ align?: 'left' | 'center' | 'right' }>`
  display: flex;
  flex-direction: column;
  align-items: ${({ align }) => {
    if (align === 'center') return 'center';
    if (align === 'right') return 'flex-end';
    return 'flex-start';
  }};
  text-align: ${({ align }) => align || 'left'};
  width: 100%;
  flex-shrink: 0;
  gap: 4px;

  .label {
    margin: 0;
  }
`;
function LabelSet({
  required,
  infoLink,
  label,
  description,
  labelWidth,
  align = 'left',
}: LabelSetProps) {
  return (
    <LabelWrap
      className="label-section"
      style={{ width: labelWidth || '100%' }}
      align={align}
    >
      <Label required={required} infoLink={infoLink} hasDescription={!!description}>
        {label}
      </Label>
      {description && (
        <p
          style={{
            fontSize: '12px',
            color: 'var(--subTextColor)',
            margin: '0 0 12px 0',
            lineHeight: '1.2',
          }}
        >
          {description}
        </p>
      )}
    </LabelWrap>
  );
}

export default LabelSet;
